import {
    isTodoFolderDescriptor,
    isTodoMyDayDescriptor,
    isTodoDueDateDescriptor,
} from './typeGuards';
import { TodoDescriptorWithId } from '../schema/TodoDescriptor';
import { assertNever } from 'owa-assert';
import { TodoDueDateDescriptor } from '../schema/TodoDueDateDescriptor';
import { containsDateRange } from 'owa-datetime-utils';

/**
 * Checks if descriptor1 constains descriptor2, descriptor1 contains descriptor2 if all the elements represented by descriptor2
 * are also represented by descriptor1.
 * @param descriptor1
 * @param descriptor2
 */
export function containsDescriptor(
    descriptor1: TodoDescriptorWithId,
    descriptor2: TodoDescriptorWithId
): boolean {
    if (descriptor1.type !== descriptor2.type) {
        return false;
    }
    if (isTodoFolderDescriptor(descriptor1)) {
        return descriptor1.Id === descriptor2.Id;
    } else if (isTodoDueDateDescriptor(descriptor1)) {
        if (descriptor1.isComplete !== descriptor2.isComplete) {
            return false;
        }
        const dateRange1 = { start: descriptor1.startDate, end: descriptor1.endDate };
        const dateRange2 = {
            start: (descriptor2 as TodoDueDateDescriptor).startDate,
            end: (descriptor2 as TodoDueDateDescriptor).endDate,
        };
        //  Checks if the inside range is included within the outside range
        return containsDateRange(
            dateRange1 /** outside range */,
            dateRange2 /** inside range */,
            true
        );
    } else if (isTodoMyDayDescriptor(descriptor1)) {
        return descriptor1.Id === descriptor2.Id;
    }
    return assertNever(descriptor1);
}
